import React from 'react';
import { FormSection } from '../../components/form-section';
import { Input } from '../../components/Input';
import { FieldLabel } from '../../components/textfield';
import { EntryDto } from '../../core/api/StudioClient';

const rowClasses =
    'grid grid-cols-[150px_minmax(0,1fr)] items-center gap-3 border-b py-1.5 last:border-b-0';

interface AdditionalDataProps {
    data: EntryDto[];
}

export const AdditionalData = ({ data }: AdditionalDataProps) => (
    <FormSection title="Additional data">
        {data.map(({ key, value }) => (
            <div key={key} className={rowClasses}>
                <FieldLabel label={key} />
                <div className="rounded-md bg-muted/40 px-2 opacity-70">
                    <Input value={value} disabled />
                </div>
            </div>
        ))}
    </FormSection>
);
